import React from 'react';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { PAGE_CONFIG } from './pageConfig';
import './index.scss';

const reqParams = '/dauByRegion';

const DauByRegion = () => {
  return (
    <div className="dbd-dau-by-region dbd-scroll-body">
      {/* @ts-ignore */}
      <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG} />
    </div>
  );
};

export default DauByRegion;
